<template>
    <div class="map-section">

        <gmap-map
            ref="mainMap"
            :center="startLocation"
            :zoom="9"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
            :options="{
                // zoomControl: false,
                scaleControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                disableDefaultUi: false,
                styles: mapStyles
            }" >

            <!-- <google-map-cluster> -->
                <div v-for="(day, dayKey, dayId) in days" :key="dayKey">

                    <gmap-marker
                    v-for="(event, eventKey, eventId) in day.events"
                    :key="eventKey"
                    :position="getPosition(event)"
                    :clickable="true"
                    :icon="getMarkers(dayId)"
                    :options="{
                      zIndex: dayId == currentDay ? 100 : 70,
                    }"
                    @mouseover="toggleInfo(event, dayId)"
                    @click="scrollTo(dayId, eventId)"
                    ></gmap-marker>

                    <gmap-info-window
                        :options="infoOptions"
                        :position="infoPos"
                        :opened="infoOpen"
                        @closeclick="infoOpen=false"
                    >
                        <p style="color: #000; margin: 0">{{infoTitle}} | {{infoDate}}</p>
                    </gmap-info-window>
                </div>
            <!-- </google-map-cluster> -->

        </gmap-map>

    </div>
</template>

<script>
// import GoogleMapCluster from 'vue2-google-maps/dist/components/cluster'

export default {
  name: "Map",
  components: {
    // GoogleMapCluster
  },
  data: function() {
    let mapMarker =
      process.env.BASE_URL+"images/pin-pasive.png";
    let mapMarkerActive =
      process.env.BASE_URL+"images/pin-active.png";
    return {
      mapStyles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"lightness":"3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
      mapMarker,
      mapMarkerActive,
      startLocation: {
        lat: 44.383513,
        lng: 19.102274
      },
      currentDay: null,
      selectedMarker: null,
      days: this.$i18n.t('days'),
      infoPos: {
        lat: 0,
        lng: 0
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoTitle: '',
      infoDate: '',
      infoOpen: false,
      currentMidx: null,
    };
  },
  computed: {},
  methods: {
    getMarkers(key) {
      if (this.currentDay == key) {
        return this.mapMarkerActive
      } else {
        return this.mapMarker;
      }
    },
    getPosition: function(marker) {
      return {
        lat: parseFloat(marker.location.lat),
        lng: parseFloat(marker.location.lng)
      };
    },
    toggleInfo: function(marker, id) {
        this.infoPos = { "lat": Number(marker.location.lat), "lng": Number(marker.location.lng)};
        this.infoTitle = marker.shortTitle
        this.infoDate = marker.date

        if (this.currentMidx == id) {
          this.infoOpen = !this.infoOpen
        }
        else {
          this.infoOpen = true
          this.currentMidx = id
        }
    },
    dayInViewport (dayId) {
      this.infoOpen = false
      this.currentDay = dayId
    },
    scrollTo(dayId, eventId) {
      this.$emit('show-custom-day', dayId, eventId)
      this.$store.dispatch('updateMapModalState', false)
    }
  }
};
</script>
